import efLogo from '../../img/ef-logo.svg'

export const efLogoUrl = efLogo
export const EfLogo = () => {
  return (
    <img src={efLogo} />
  )
}
